/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { Component } from "react";
import Button from "../UI/Button";
import { fileField } from "./FormFieldsStyles";

class FileInputButton extends Component {
    handleChange = fileOnChange => file => {
        fileOnChange(file);
    };

    render() {
        const { id, label, input, ...rest } = this.props;
        return (
            <div>
                <div css={fileField.hidden}>
                    <FileBase64
                        onDone={this.handleChange(input.onChange)}
                        type="file"
                        id={id}
                        {...{ input, rest }}
                    />
                </div>
                <label htmlFor={id}>
                    <Button
                        textIcon={{
                            name: "add",
                            width: 12,
                            height: 12,
                        }}
                        small
                        component="span"
                    >
                        {input.value.name ? input.value.name : label}
                    </Button>
                </label>
            </div>
        );
    }
}

/*! Copyright (c) 2016 Naufal Rabbani (http://github.com/BosNaufal)
 * Licensed Under MIT (http://opensource.org/licenses/MIT)
 *
 * React File Base64 - Version@1.0.0
 *
 */

export class FileBase64 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            files: [],
        };
    }

    handleChange(e) {
        // get the files
        let files = e.target.files;

        // Process each file
        var allFiles = [];
        for (var i = 0; i < files.length; i++) {
            let file = files[i];

            // Make new FileReader
            let reader = new FileReader();

            // Convert the file to base64 text
            reader.readAsDataURL(file);

            // on reader load somthing...
            reader.onload = () => {
                // Make a fileInfo Object
                let fileInfo = {
                    name: file.name,
                    type: file.type,
                    size: Math.round(file.size / 1000) + " kB",
                    base64: reader.result,
                    file: file,
                };

                // Push it to the state
                allFiles.push(fileInfo);

                // If all files have been proceed
                if (allFiles.length === files.length) {
                    // Apply Callback function
                    if (this.props.multiple) this.props.onDone(allFiles);
                    else this.props.onDone(allFiles[0]);
                }
            }; // reader.onload
        } // for
    }

    render() {
        return (
            <input
                type="file"
                onChange={this.handleChange.bind(this)}
                multiple={this.props.multiple}
                id={this.props.id}
            />
        );
    }
}

FileBase64.defaultProps = {
    multiple: false,
};

export default FileInputButton;
